import { render } from "./EventJournalHeader.vue?vue&type=template&id=42a8720d&scoped=true"
import script from "./EventJournalHeader.vue?vue&type=script&lang=js"
export * from "./EventJournalHeader.vue?vue&type=script&lang=js"

import "./EventJournalHeader.vue?vue&type=style&index=0&id=42a8720d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42a8720d"]])

export default __exports__